// Global cities and countries for cost of living calculations
export const GLOBAL_REGIONS = {
  'North America': {
    'United States': ['New York', 'Los Angeles', 'San Francisco', 'Chicago', 'Boston', 'Seattle', 'Austin', 'Miami', 'Denver', 'Portland'],
    'Canada': ['Toronto', 'Vancouver', 'Montreal', 'Calgary', 'Ottawa', 'Edmonton'],
    'Mexico': ['Mexico City', 'Guadalajara', 'Monterrey', 'Cancun', 'Tijuana']
  },
  'Europe': {
    'United Kingdom': ['London', 'Manchester', 'Edinburgh', 'Birmingham', 'Bristol'],
    'Germany': ['Berlin', 'Munich', 'Frankfurt', 'Hamburg', 'Cologne'],
    'France': ['Paris', 'Lyon', 'Marseille', 'Toulouse', 'Nice'],
    'Spain': ['Madrid', 'Barcelona', 'Valencia', 'Seville', 'Bilbao'],
    'Italy': ['Rome', 'Milan', 'Florence', 'Venice', 'Naples'],
    'Netherlands': ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht'],
    'Switzerland': ['Zurich', 'Geneva', 'Basel', 'Bern'],
    'Sweden': ['Stockholm', 'Gothenburg', 'Malmo'],
    'Norway': ['Oslo', 'Bergen', 'Trondheim'],
    'Denmark': ['Copenhagen', 'Aarhus', 'Odense'],
    'Ireland': ['Dublin', 'Cork', 'Galway'],
    'Portugal': ['Lisbon', 'Porto', 'Faro'],
    'Austria': ['Vienna', 'Salzburg', 'Innsbruck'],
    'Belgium': ['Brussels', 'Antwerp', 'Ghent'],
    'Poland': ['Warsaw', 'Krakow', 'Wroclaw'],
    'Czech Republic': ['Prague', 'Brno', 'Ostrava']
  },
  'Asia': {
    'Japan': ['Tokyo', 'Osaka', 'Kyoto', 'Yokohama', 'Fukuoka'],
    'China': ['Shanghai', 'Beijing', 'Shenzhen', 'Guangzhou', 'Hong Kong'],
    'Singapore': ['Singapore'],
    'South Korea': ['Seoul', 'Busan', 'Incheon'],
    'India': ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Pune'],
    'Thailand': ['Bangkok', 'Chiang Mai', 'Phuket'],
    'Vietnam': ['Ho Chi Minh City', 'Hanoi', 'Da Nang'],
    'Malaysia': ['Kuala Lumpur', 'Penang', 'Johor Bahru'],
    'Indonesia': ['Jakarta', 'Bali', 'Surabaya'],
    'Philippines': ['Manila', 'Cebu', 'Davao'],
    'Taiwan': ['Taipei', 'Kaohsiung', 'Taichung'],
    'UAE': ['Dubai', 'Abu Dhabi'],
    'Israel': ['Tel Aviv', 'Jerusalem', 'Haifa']
  },
  'Oceania': {
    'Australia': ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide'],
    'New Zealand': ['Auckland', 'Wellington', 'Christchurch']
  },
  'South America': {
    'Brazil': ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador'],
    'Argentina': ['Buenos Aires', 'Córdoba', 'Rosario'],
    'Chile': ['Santiago', 'Valparaíso', 'Concepción'],
    'Colombia': ['Bogotá', 'Medellín', 'Cartagena'],
    'Peru': ['Lima', 'Cusco', 'Arequipa']
  },
  'Africa': {
    'South Africa': ['Cape Town', 'Johannesburg', 'Durban'],
    'Kenya': ['Nairobi', 'Mombasa'],
    'Egypt': ['Cairo', 'Alexandria'],
    'Morocco': ['Casablanca', 'Marrakech', 'Rabat'],
    'Nigeria': ['Lagos', 'Abuja']
  }
};

// Keep US states data for backward compatibility
export const US_STATES_CITIES = {
  'Alabama': ['Birmingham', 'Montgomery', 'Mobile'],
  'Alaska': ['Anchorage', 'Fairbanks', 'Juneau'],
  'Arizona': ['Phoenix', 'Tucson', 'Mesa'],
  'Arkansas': ['Little Rock', 'Fort Smith', 'Fayetteville'],
  'California': ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose', 'Sacramento'],
  'Colorado': ['Denver', 'Colorado Springs', 'Aurora'],
  'Connecticut': ['Hartford', 'New Haven', 'Stamford'],
  'Delaware': ['Wilmington', 'Dover', 'Newark'],
  'Florida': ['Miami', 'Orlando', 'Tampa', 'Jacksonville'],
  'Georgia': ['Atlanta', 'Augusta', 'Columbus'],
  'Hawaii': ['Honolulu', 'Hilo', 'Kailua'],
  'Idaho': ['Boise', 'Meridian', 'Nampa'],
  'Illinois': ['Chicago', 'Aurora', 'Naperville'],
  'Indiana': ['Indianapolis', 'Fort Wayne', 'Evansville'],
  'Iowa': ['Des Moines', 'Cedar Rapids', 'Davenport'],
  'Kansas': ['Wichita', 'Overland Park', 'Kansas City'],
  'Kentucky': ['Louisville', 'Lexington', 'Bowling Green'],
  'Louisiana': ['New Orleans', 'Baton Rouge', 'Shreveport'],
  'Maine': ['Portland', 'Lewiston', 'Bangor'],
  'Maryland': ['Baltimore', 'Frederick', 'Rockville'],
  'Massachusetts': ['Boston', 'Worcester', 'Springfield'],
  'Michigan': ['Detroit', 'Grand Rapids', 'Warren'],
  'Minnesota': ['Minneapolis', 'Saint Paul', 'Rochester'],
  'Mississippi': ['Jackson', 'Gulfport', 'Southaven'],
  'Missouri': ['Kansas City', 'Saint Louis', 'Springfield'],
  'Montana': ['Billings', 'Missoula', 'Great Falls'],
  'Nebraska': ['Omaha', 'Lincoln', 'Bellevue'],
  'Nevada': ['Las Vegas', 'Henderson', 'Reno'],
  'New Hampshire': ['Manchester', 'Nashua', 'Concord'],
  'New Jersey': ['Newark', 'Jersey City', 'Paterson'],
  'New Mexico': ['Albuquerque', 'Las Cruces', 'Rio Rancho'],
  'New York': ['New York', 'Buffalo', 'Rochester'],
  'North Carolina': ['Charlotte', 'Raleigh', 'Greensboro'],
  'North Dakota': ['Fargo', 'Bismarck', 'Grand Forks'],
  'Ohio': ['Columbus', 'Cleveland', 'Cincinnati'],
  'Oklahoma': ['Oklahoma City', 'Tulsa', 'Norman'],
  'Oregon': ['Portland', 'Salem', 'Eugene'],
  'Pennsylvania': ['Philadelphia', 'Pittsburgh', 'Allentown'],
  'Rhode Island': ['Providence', 'Warwick', 'Cranston'],
  'South Carolina': ['Charleston', 'Columbia', 'North Charleston'],
  'South Dakota': ['Sioux Falls', 'Rapid City', 'Aberdeen'],
  'Tennessee': ['Nashville', 'Memphis', 'Knoxville'],
  'Texas': ['Houston', 'San Antonio', 'Dallas', 'Austin'],
  'Utah': ['Salt Lake City', 'West Valley City', 'Provo'],
  'Vermont': ['Burlington', 'South Burlington', 'Rutland'],
  'Virginia': ['Virginia Beach', 'Norfolk', 'Chesapeake'],
  'Washington': ['Seattle', 'Spokane', 'Tacoma'],
  'West Virginia': ['Charleston', 'Huntington', 'Morgantown'],
  'Wisconsin': ['Milwaukee', 'Madison', 'Green Bay'],
  'Wyoming': ['Cheyenne', 'Casper', 'Laramie']
};
